import BaseModel from './BaseModel'

export default class VehicleMake extends BaseModel {
  // ... VehicleMake-specific methods or overrides ...
}
